import {gsap} from "gsap";

var toBorderRadius = '340';
const mq = window.matchMedia( "(min-width: 990px)" );
if (!mq.matches) {
    var toBorderRadius = '100';
}

window.addEventListener("resize", function() {
    const mq = window.matchMedia( "(min-width: 990px)" );

    if (mq.matches) {
        var toBorderRadius = '340';
    } else {
        var toBorderRadius = '100';
    }
})

document.addEventListener('DOMContentLoaded', (event) => {
    const elem = document.querySelector('.two-column-content-image__content');

    if( elem ) {
        gsap.to(elem, {
            scrollTrigger: {
                trigger: ".two-column-content-image",
                start: "20px bottom",
                // markers: true,
                scrub: 1
            },
            borderTopLeftRadius: '+=' + toBorderRadius + 'px',
            borderBottomRightRadius: '+=' + toBorderRadius + 'px',
            duration: 1
        })
    }
})